import * as XLSX from "xlsx";

import { Button, Input, Loader } from "@mantine/core";
import {
  IconArrowLeft,
  IconLayoutGridFilled,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import { Modal, Table, Upload, notification } from "antd";
import { orpcClient } from "@/lib/orpc-client";
import { useEffect, useState } from "react";

import Papa from "papaparse";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface SteelBoltItem {
  key: number;
  name: string;
  b: string;
  c: string;
  d: string;
  e: string;
  f: string;
  documentId?: string;
}

function AddSteelBoltPage() {
  const { t } = useTranslation();
  const [fileUpload, setFileUpload] = useState<SteelBoltItem[]>([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { id } = useParams();
  const navigate = useNavigate();

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [fileUpload]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: SteelBoltItem[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
    },
    getCheckboxProps: (record: SteelBoltItem) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const handleChangePayableDetail = (
    documentId: string | number,
    value: string,
    type: string,
  ) => {
    setFileUpload((prev) => {
      const updatedList = prev.map((payable) => {
        if (payable.documentId === documentId || payable?.key === documentId) {
          return {
            ...payable,
            [type]: value,
          };
        }
        return payable;
      });

      return updatedList;
    });
  };

  const handleChangeFile = (
    info: any,
    setFileUpload: React.Dispatch<React.SetStateAction<SteelBoltItem[]>>,
  ) => {
    const file = info.file.originFileObj;
    if (!file) return;

    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";
    const isCsv =
      file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

    if (isExcel) {
      const reader = new FileReader();

      reader.onload = (e) => {
        if (!e.target?.result) return;
        const data = new Uint8Array(e.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
        }) as any[];

        const formattedData = processFileData(jsonData);
        setFileUpload(formattedData);
      };

      reader.readAsArrayBuffer(file);
    } else if (isCsv) {
      Papa.parse(file, {
        header: false,
        skipEmptyLines: true,
        complete: (results: any) => {
          const csvData = results.data.map((row: any) => {
            const obj: any = { 新建工程: row[0] || "" };
            row.forEach((cell: any, index: number) => {
              if (index === 0) return;
              if (index === 1) obj.__EMPTY = cell || "";
              else obj[`__EMPTY_${index - 1}`] = cell || "";
            });
            return obj;
          });
          const formattedData = processFileData(csvData);
          setFileUpload(formattedData);
        },
        error: (error: any) => {
          console.error("CSV parsing error:", error);
        },
      });
    } else {
      setFileUpload((prev) => [
        ...prev,
        {
          id: Date.now(),
          name: file.name,
        } as any,
      ]);
    }
  };

  const processFileData = (jsonData: any[]): SteelBoltItem[] => {
    const filteredData = jsonData.filter((item) => {
      let part = String(Object.values(item)[0]).trim();
      return part === "SteelBolts";
    });

    return filteredData.map((item, index) => ({
      key: index,
      name: item?.新建工程 || "",
      b: item?.__EMPTY || "",
      c: item?.__EMPTY_1 || "",
      d: item?.__EMPTY_2 || "",
      e: item?.__EMPTY_3 || "",
      f: item?.__EMPTY_4 || "",
    }));
  };

  const columns = [
    // {
    //   title: '螺絲',
    //   dataIndex: 'name',

    //   render: (text, i) => {
    //     return (
    //       <Input
    //         placeholder="Input component"
    //         //leftSection={<IconMail size={16} />}
    //         value={text}
    //         onChange={(e) =>
    //           handleChangePayableDetail(i?.documentId || i?.key, e.target.value, 'name')
    //         }
    //       />
    //     );
    //   },
    // },
    {
      title: "材質規格-直徑-長度",
      dataIndex: "b",

      render: (text: any, i: SteelBoltItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "b",
              )
            }
          />
        );
      },
    },
    {
      title: "類型",
      dataIndex: "c",
      render: (text: any, i: SteelBoltItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "c",
              )
            }
          />
        );
      },
    },
    {
      title: "數量",
      dataIndex: "d",
      render: (text: any, i: SteelBoltItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "d",
              )
            }
          />
        );
      },
    },
    {
      title: "材質",
      dataIndex: "e",
      render: (text: any, i: SteelBoltItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "e",
              )
            }
          />
        );
      },
    },
    {
      title: "單位重(kg/m)",
      dataIndex: "f",
      render: (text: any, i: SteelBoltItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "f",
              )
            }
          />
        );
      },
    },
    {
      title: "",
      fixed: "right",
      render: ({ key }: { key: React.Key }) => {
        return (
          <>
            <div>
              <Button
                variant="filled"
                color="gray"
                style={{ margin: "0.3rem" }}
                radius="md"
                // onClick={async () => {
                //   let result = await apiUserDeleteAccountsPayable({
                //     id: displayAccountPayable[key - 1]?.documentId,
                //   });
                //   fetchPayableData();
                // }}
              >
                編輯
              </Button>
            </div>
          </>
        );
      },
    },
  ];

  const handleUploadExcel = async (data: SteelBoltItem[]) => {
    setIsUploading(true);
    const CHUNK_SIZE = 50;
    const allResults: any[] = [];

    try {
      for (let i = 0; i < data.length; i += CHUNK_SIZE) {
        const chunk = data.slice(i, i + CHUNK_SIZE);
        console.log(
          `Processing chunk ${Math.floor(i / CHUNK_SIZE) + 1}/${Math.ceil(data.length / CHUNK_SIZE)} (${chunk.length} items)`,
        );

        const batch = await orpcClient.steelBoltBom.create(
          chunk.map((element) => ({
            projectId: id!,
            materialSpec: element?.b ? String(element.b).trim() : "",
            type: element?.c ? String(element.c).trim() : "",
            quantity: element?.d ? parseInt(String(element.d).trim()) : 0,
            material: element?.e ? String(element.e).trim() : "",
            unitWeight: element?.f ? parseFloat(String(element.f).trim()) : 0,
          })),
        );
        const chunkResults = batch.map((res) =>
          res.success
            ? { status: "fulfilled" as const, value: res.data }
            : { status: "rejected" as const, reason: res.error },
        );

        allResults.push(...chunkResults);

        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      const failedResults = allResults.filter(
        (result) => result.status === "rejected",
      );
      const successCount = allResults.length - failedResults.length;

      setIsUploading(false);

      if (failedResults.length > 0) {
        console.error("Upload errors:", failedResults);
        api.error({
          message: `通知`,
          description: (
            <div>
              {t("steelBoltBOM.uploadPartialError", {
                failed: failedResults.length,
                success: successCount,
              })}
            </div>
          ),
          placement: "topLeft",
          duration: 0,
        });
      } else {
        api.success({
          message: `通知`,
          description: (
            <div>
              {t("steelBoltBOM.uploadSuccess", { count: successCount })}
            </div>
          ),
          placement: "topLeft",
          duration: 3,
        });
        navigate(`/hrMainPage/steelBoltBOM/${id}`);
      }
    } catch (e) {
      setIsUploading(false);
      console.error("Upload error:", e);
      api.error({
        message: `通知`,
        description: (
          <div>
            {(e as any)?.response?.data?.error?.message ||
              t("steelBoltBOM.uploadError")}
          </div>
        ),
        placement: "topLeft",
        duration: 0,
      });
    }
  };

  useEffect(() => {
    setIsUploadModalOpen(true);
  }, []);

  return (
    <div className="px-8 m-8">
      {contextHolder}
      {isUploading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size="xl" color="blue" />
        </div>
      )}
      <div
        className="flex items-center justify-between px-4"
        style={{ backgroundColor: "#ECECEC", marginBottom: "1rem" }}
      >
        <div className="flex justify-start">
          <Button
            variant="filled"
            color="red"
            onClick={() => setFileUpload([])}
          >
            刪除Excel
          </Button>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            color="gray"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate(`/hrMainPage/steelBoltBOM/${id}`)}
          >
            返回鋼材螺栓BOM
          </Button>
          <Button variant="default" onClick={() => setIsUploadModalOpen(true)}>
            匯入構件
          </Button>
          <Button
            variant="default"
            onClick={() => handleUploadExcel(fileUpload)}
          >
            儲存Excel
          </Button>
        </div>
      </div>
      <Table
        scroll={{ x: "max-content", y: 600 }}
        columns={columns}
        dataSource={fileUpload}
        pagination={{
          pageSize: pageSize,
          total: fileUpload.length,
          current: currentPage,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100", "200"],
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        bordered
        sticky
      />

      <Modal
        title="匯入Excel或CSV檔案"
        open={isUploadModalOpen}
        onCancel={() => setIsUploadModalOpen(false)}
        footer={null}
        width={600}
      >
        <div className="flex flex-col items-center justify-center p-8">
          <Upload
            name="avatar"
            showUploadList={false}
            onChange={(info) => handleChangeFile(info, setFileUpload)}
            accept=".xlsx,.xls,.csv"
          >
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-500 transition-colors">
              <div className="text-lg font-medium text-gray-700 mb-2">
                點擊或拖拽Excel或CSV檔案到此處
              </div>
              <div className="text-sm text-gray-500">
                支援 .xlsx、.xls 和 .csv 格式
              </div>
            </div>
          </Upload>

          {fileUpload.length > 0 && (
            <div className="mt-4 w-full">
              <div className="text-sm text-gray-600 mb-2">
                已載入 {fileUpload.length} 筆資料
              </div>
              <div className="flex gap-2">
                <Button
                  variant="default"
                  onClick={() => setIsUploadModalOpen(false)}
                >
                  關閉
                </Button>
                <Button
                  variant="filled"
                  color="blue"
                  onClick={() => {
                    handleUploadExcel(fileUpload);
                    setIsUploadModalOpen(false);
                  }}
                >
                  確認匯入
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default AddSteelBoltPage;
